import { useEffect } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { ROUTES } from "@/helpers/routes"
import { useGetMatchSessionQuery } from "@/store/apis/matchAPI"
import { useGetPlayerProfileQuery } from "@/store/apis/playerAPI"
import { useAppSelector } from "@/store/index"
import { GameplaySelectors } from "@/store/slices/gameplay"
import { PlayerSelectors } from "@/store/slices/player"

export const useCheckInGame = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const sessionIdStore = useAppSelector(GameplaySelectors.selectSessionId())
  const isPlayerLoaded = useAppSelector(PlayerSelectors.selectIsPlayerLoaded())

  const { data: playerProfile } = useGetPlayerProfileQuery()

  const { sessionId: sessionIdParam } = useParams<"sessionId">()
  const sessionIdTgParam = window.location.search.split("match_")[1]

  const sessionId = sessionIdStore || sessionIdTgParam || sessionIdParam

  const { data: matchSession, isLoading: isMatchSessionLoading } =
    useGetMatchSessionQuery(
      {
        sessionId: sessionId || "",
        playerId: playerProfile?._id || ""
      },
      {
        skip: !sessionId || !playerProfile?._id
      }
    )

  useEffect(() => {
    if (!sessionId || !isPlayerLoaded) {
      return
    }

    if (isMatchSessionLoading || !matchSession) {
      return
    }

    if (matchSession.status === "PENDING") {
      if (location.pathname.includes("/match")) {
        navigate(ROUTES.HOME, { replace: true })
        return
      }

      return
    }

    navigate(ROUTES.MATCH(sessionId), { replace: true })
  }, [isPlayerLoaded, sessionId, isMatchSessionLoading, matchSession])
}
